// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';

// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
import { IRootState } from './types';

// Types

const initialState: IRootState = {
  selectedArticle: {} as IRootState['selectedArticle'],
  isOpenFeedbackNav: false,
  isOpenDiscordNav: false,
  searchArticle: '',
};
export const slice = createSlice({
  name: STORE_SLICES.HELP,
  initialState,
  reducers,
});
const helpActions = slice.actions;

const helpPersistConfig = {
  key: PERSIST_KEYS.HELP,
  storage,
  whitelist: ['selectedArticle'],
};

export {
  helpActions,
};

export default persistReducer(helpPersistConfig, slice.reducer);
